import React, { Component } from 'react';
import './App.css';

export default class Peinture extends Component {
  render() {
    return (
      <div className="card">
  <img className="card-img-top img-thumbnail img-fluid peinture-img" src={this.props.peinture.img} alt="Card image cap" />
  <div class="card-footer">
  <p className="card-title">{this.props.peinture.titre}</p>
      <small class="text-muted">{this.props.peinture.detail}, {this.props.peinture.annee}</small>
    </div>
        </div>
       
    );
}
}




// WEBPACK FOOTER //
// ./src/Peinture.js